
const InfoSection = (props) => {
    return (
        <div className={'info-section' + (props.ClassName ? ' ' + props.ClassName : '')}>
            {props.Title &&
                <strong>{props.Title}</strong>}
            {props.Description &&
                <p dangerouslySetInnerHTML={{ __html: props.Description }}></p>}
            {(props.Paragraphs && props.Paragraphs.length > 0) &&
                <div>
                    {props.Paragraphs.map((obj, i) =>
                        <p key={i} dangerouslySetInnerHTML={{ __html: obj }}></p>)}
                </div>}
            {(props.Bullets && props.Bullets.length > 0) &&
                <ul>
                    {props.Bullets.map((obj, i) =>
                        <li key={i} dangerouslySetInnerHTML={{ __html: obj }}></li>)}
                </ul>}
        </div>
    );
};

export default InfoSection;